import { render, staticRenderFns } from "./IncidentDetail.vue?vue&type=template&id=af754012&scoped=true"
import script from "./IncidentDetail.vue?vue&type=script&lang=js"
export * from "./IncidentDetail.vue?vue&type=script&lang=js"
import style0 from "./IncidentDetail.vue?vue&type=style&index=0&id=af754012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af754012",
  null
  
)

export default component.exports